import {
  createContactNoteCommentV1,
  deleteContactNoteCommentV1,
  updateContactNoteCommentV1,
} from "@/lib/data/requests";
import { type APIError } from "@/lib/types";
import { toastAPIErrorMessage } from "@/lib/utils/axiosUtils";
import { useMutation } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import toast from "react-hot-toast";
import { useContactInvalidation } from "@/hooks/use-contact-invalidation";

export const useCreateContactNoteComment = () => {
  const invalidateContact = useContactInvalidation();
  return useMutation({
    mutationFn: (data: Parameters<typeof createContactNoteCommentV1>[0]) =>
      createContactNoteCommentV1(data),
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error creating contact note comment");
    },
    onSettled: async () => {
      await invalidateContact();
    },
    onSuccess: () => {
      toast.success("Contact note comment created successfully");
    },
  });
};

export const useUpdateContactNoteComment = () => {
  const invalidateContact = useContactInvalidation();
  return useMutation({
    mutationFn: (data: Parameters<typeof updateContactNoteCommentV1>[0]) =>
      updateContactNoteCommentV1(data),
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error updating contact note comment");
    },
    onSettled: async () => {
      await invalidateContact();
    },
    onSuccess: () => {
      toast.success("Contact note comment updated successfully");
    },
  });
};

export const useDeleteContactNoteComment = () => {
  const invalidateContact = useContactInvalidation();
  return useMutation({
    mutationFn: (data: Parameters<typeof deleteContactNoteCommentV1>[0]) =>
      deleteContactNoteCommentV1(data),
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error deleting contact note comment");
    },
    onSettled: async () => {
      await invalidateContact();
    },
    onSuccess: () => {
      toast.success("Contact note comment deleted successfully");
    },
  });
};
